import PropTypes from 'prop-types';

function IFSaleActive({ className, width }) {
    return (
        <svg width={width} className={className} viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5528 14.8788C22.8684 13.4435 23.1076 12.2475 21.5528 10.4534C20.1175 8.77896 14.2569 3.15753 12.702 1.72228C11.3864 0.526228 9.71191 0.287019 8.03745 0.526228L2.65523 1.36346C2.05721 1.48307 1.45918 1.96149 1.33958 2.55951L0.621948 6.98489C0.382739 8.42015 0.263134 10.3338 1.10037 11.2907C2.77483 13.2043 8.87468 19.7826 11.0276 21.6963C13.0608 23.4903 14.4961 22.0551 15.5725 20.859L21.5528 14.8788ZM6.12377 7.82212C7.20021 7.82212 7.91784 6.98489 7.91784 6.02805C7.91784 5.07121 7.08061 4.23398 6.12377 4.23398C5.04733 4.23398 4.21009 5.07121 4.21009 6.02805C4.21009 6.98489 5.04733 7.82212 6.12377 7.82212Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M15.8118 17.5103L14.9745 16.5534C13.5393 17.3906 12.4628 17.1514 11.2668 15.9554L12.9412 14.5201C13.5393 14.9986 14.0177 15.1182 14.6157 14.6397C15.0941 14.1613 15.2137 13.6829 14.8549 13.3241C14.3765 12.8457 13.6589 13.3241 12.9412 13.6829C11.8648 14.2809 10.5491 14.9986 9.35309 13.6829C8.63547 12.7261 8.63547 11.53 9.4727 10.2144L8.39626 9.13792L9.83151 7.82227L10.908 8.89871C12.104 8.30068 13.1804 8.42029 14.2569 9.37713L12.702 10.8124C12.104 10.334 11.8648 10.334 11.2668 10.6928C10.7884 11.1712 10.7884 11.53 11.1472 11.7692C11.6256 12.2476 12.3432 11.7692 12.9412 11.2908C14.0177 10.6928 15.4529 9.97515 16.649 11.4104C17.4862 12.3672 17.6058 13.6829 16.7686 14.8789L17.6058 15.8358L15.8118 17.5103Z"
                fill="#2D2D2D"
            />
        </svg>
    );
}

export default IFSaleActive;

IFSaleActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFSaleActive.defaultProps = {
    className: null,
};
